import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotesTextArea from '../../components/fields/NotesTextArea';
import ReasonForEscalationSelect from '../../components/fields/ReasonForEscalationSelect';
import { saveEscalation } from '../../actions/EscalationActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DeliverabilityEscalation() {
  const dispatch = useDispatch();
  const escalation = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalation);
  const escalationMeta = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalationMeta);
  const savingState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.savingState);
  const escalationReasons = useMemo(() => escalationMeta.deliverabilityEscalationReasons.map(reason => ({
    text: reason.description,
    value: reason.id
  })).toJS(), [escalationMeta]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(ReasonForEscalationSelect, {
        "data-test-id": "reason-for-escalation-select",
        isSaving: savingState.reason,
        onSelect: option => dispatch(saveEscalation(escalation.setReason(option).toJS(), 'reason')),
        options: escalationReasons,
        selectedOption: escalation.reason
      })
    }), /*#__PURE__*/_jsx(NotesTextArea, {
      currentText: escalation.notes,
      isSaving: savingState.notes,
      "data-test-id": "notes-text-area",
      onTextChange: text => dispatch(saveEscalation(escalation.setNotes(text).toJS(), 'notes'))
    })]
  });
}
export default DeliverabilityEscalation;